function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter, getDefaultOffset } from '@bydesign-ui/hooks';
import { AxisType } from '../enum';
export var Point = function (_Emitter) {
  _inherits(Point, _Emitter);

  var _super = _createSuper(Point);

  function Point(region, type, name) {
    var _this;

    _classCallCheck(this, Point);

    _this = _super.call(this);
    _this.offset = getDefaultOffset();
    _this.dragging = false;
    _this.region = region;
    _this.type = type;
    _this.name = name;
    return _this;
  }

  _createClass(Point, [{
    key: "getPointName",
    value: function getPointName() {
      return this.name;
    }
  }, {
    key: "getPointType",
    value: function getPointType() {
      return this.type;
    }
  }, {
    key: "getAxis",
    value: function getAxis(type) {
      return this.region.getAxis(type);
    }
  }, {
    key: "getRegion",
    value: function getRegion() {
      return this.region;
    }
  }, {
    key: "getOffset",
    value: function getOffset() {
      return this.offset;
    }
  }, {
    key: "getPointValue",
    value: function getPointValue() {
      return this.region.getPointValue(this.name);
    }
  }, {
    key: "setPointValue",
    value: function setPointValue(value, virtual) {
      this.region.setPointValue(this.name, value, virtual);
    }
  }, {
    key: "getDragging",
    value: function getDragging() {
      return this.dragging;
    }
  }, {
    key: "setDragging",
    value: function setDragging(dragging) {
      this.dragging = dragging;
      this.region.setDragging(dragging);
    }
  }, {
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    }
  }, {
    key: "updatePointValue",
    value: function updatePointValue() {
      var _this$getPointValue = this.getPointValue(),
          x = _this$getPointValue.x,
          y = _this$getPointValue.y;

      this.offset = {
        x: this.getAxis(AxisType.HORIZONTAL).getValueOffset(x) || 0,
        y: this.getAxis(AxisType.VERTICAL).getValueOffset(y) || 0
      };
      this.repaint();
    }
  }, {
    key: "updateRealOffset",
    value: function updateRealOffset(start, end) {
      this.offset = this.calcNewOffsetByType(start, end);
      var virtual = this.dragging;
      var value = this.getOffsetPrecisionValue();
      var old = {
        x: this.getPrecisionValue(AxisType.HORIZONTAL),
        y: this.getPrecisionValue(AxisType.VERTICAL)
      };
      var xChangeAndValid = value.x !== old.x && this.getAxis(AxisType.HORIZONTAL).isValidValue(+value.x);
      var yChangeAndValid = value.y !== old.y && this.getAxis(AxisType.VERTICAL).isValidValue(+value.y);

      if (xChangeAndValid || yChangeAndValid) {
        this.setPointValue({
          x: xChangeAndValid ? +value.x : +old.x,
          y: yChangeAndValid ? +value.y : +old.y
        }, virtual);
      } else if (!virtual) {
        this.setPointValue({
          x: +old.x,
          y: +old.y
        });
      }

      this.region.repaint();
    }
  }, {
    key: "getOffsetPrecisionValue",
    value: function getOffsetPrecisionValue() {
      var _this$offset = this.offset,
          x = _this$offset.x,
          y = _this$offset.y;
      return {
        x: this.getAxis(AxisType.HORIZONTAL).getOffsetPrecisionValue(x),
        y: this.getAxis(AxisType.VERTICAL).getOffsetPrecisionValue(y)
      };
    }
  }, {
    key: "getPrecisionValue",
    value: function getPrecisionValue(type) {
      var _this$getPointValue2 = this.getPointValue(),
          x = _this$getPointValue2.x,
          y = _this$getPointValue2.y;

      var value = type === AxisType.HORIZONTAL ? x : y;
      return this.getAxis(type).formatPrecisionValue(value);
    }
  }, {
    key: "setPrecisionValue",
    value: function setPrecisionValue(type, value, virtual) {
      var val = +value;
      var axis = this.getAxis(type);

      var _this$getPointValue3 = this.getPointValue(),
          x = _this$getPointValue3.x,
          y = _this$getPointValue3.y;

      if (!axis.isValidValue(val)) {
        return false;
      }

      this.setPointValue({
        x: type === AxisType.HORIZONTAL ? val : x,
        y: type === AxisType.VERTICAL ? val : y
      }, virtual);
      return true;
    }
  }, {
    key: "upStep",
    value: function upStep(type) {
      var stepCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (Math.floor(stepCount) !== stepCount) {
        throw new Error("stepCount should be int, but receive ".concat(stepCount));
      }

      var _this$getPointValue4 = this.getPointValue(),
          x = _this$getPointValue4.x,
          y = _this$getPointValue4.y;

      var axis = this.getAxis(type);
      var pv = axis.stepPrecisionValue(type === AxisType.HORIZONTAL ? x : y, stepCount);
      this.setPrecisionValue(type, pv);
    }
  }, {
    key: "downStep",
    value: function downStep(type) {
      var stepCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (Math.floor(stepCount) !== stepCount) {
        throw new Error("stepCount should be int, but receive ".concat(stepCount));
      }

      var _this$getPointValue5 = this.getPointValue(),
          x = _this$getPointValue5.x,
          y = _this$getPointValue5.y;

      var axis = this.getAxis(type);
      var pv = axis.stepPrecisionValue(type === AxisType.HORIZONTAL ? x : y, -stepCount);
      this.setPrecisionValue(type, pv);
    }
  }, {
    key: "calcNewOffsetByType",
    value: function calcNewOffsetByType(start, end) {
      var x = end.x,
          y = end.y;
      var offset = {
        x: Math.min(this.getAxis(AxisType.HORIZONTAL).getAxisLength(), Math.max(0, x)),
        y: Math.min(this.getAxis(AxisType.VERTICAL).getAxisLength(), Math.max(0, y))
      };
      var canXChange = this.type & 2;
      var canYChange = this.type & 8;
      return {
        x: canXChange ? offset.x : start.x,
        y: canYChange ? offset.y : start.y
      };
    }
  }]);

  return Point;
}(Emitter);